module.exports = __webpack_public_path__ + "img/triangle_opaque.6ab68e23.svg";